import { useState } from "react";
import { useUser } from "@clerk/react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { useAuthedApi, errMsg, formatINR } from "../lib/api";

export default function LeadDialog({ open, onOpenChange, type, car }) {
  const api = useAuthedApi();
  const { user } = useUser();
  const isOffer = type === "offer";
  const [form, setForm] = useState({ name: user?.fullName || "", phone: "", message: "", offer_amount: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api("post", `/listings/${car.id}/leads`, {
        type, name: form.name, phone: form.phone, message: form.message,
        offer_amount: isOffer ? Number(form.offer_amount) : null,
      });
      toast.success(isOffer ? `Your offer of ${formatINR(Number(form.offer_amount))} has been sent to the seller` : "Enquiry sent. The seller will contact you soon.");
      onOpenChange(false);
      setForm({ ...form, message: "", offer_amount: "" });
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111319] border-[#D4AF37]/30 text-white sm:max-w-md" data-testid={`${type}-dialog`}>
        <DialogHeader>
          <DialogTitle className="font-display text-3xl gold-text">{isOffer ? "Make an Offer" : "Send Enquiry"}</DialogTitle>
          <DialogDescription className="text-gray-400">{car.year} {car.brand} {car.model} · Asking {formatINR(car.price)}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {isOffer && (
            <div>
              <label className="lux-label">Your offer (₹)</label>
              <input className="lux-input text-lg" type="number" min="1" required value={form.offer_amount} onChange={set("offer_amount")} placeholder={String(Math.round(car.price * 0.95))} data-testid="offer-amount-input" />
              {form.offer_amount > 0 && <p className="text-xs text-[#E5C158] mt-1">{formatINR(Number(form.offer_amount))}</p>}
            </div>
          )}
          <div><label className="lux-label">Your name</label><input className="lux-input" required value={form.name} onChange={set("name")} data-testid={`${type}-name-input`} /></div>
          <div><label className="lux-label">Mobile number</label><input className="lux-input" required pattern="[0-9+ ]{10,15}" value={form.phone} onChange={set("phone")} placeholder="98XXXXXXXX" data-testid={`${type}-phone-input`} /></div>
          <div><label className="lux-label">Message</label><textarea className="lux-textarea" rows={3} value={form.message} onChange={set("message")} placeholder={isOffer ? "Any conditions for your offer?" : "Is the car still available? Can I book a test drive?"} data-testid={`${type}-message-input`} /></div>
          <button className="btn-gold w-full" disabled={busy} data-testid={`${type}-submit-button`}>{busy ? "Sending..." : isOffer ? "Submit Offer" : "Send Enquiry"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
